import { Navigate, useLocation } from "react-router-dom";
import useAuthStore from "@/store/use-auth-store";
import React from "react";
// Barrel yerine doğrudan hook dosyası: guard bundle'ına quest UI girmesin.
import {
  resolvePostLoginRedirect,
  usePostLoginGate,
} from "@/features/persona-setup/hooks/use-post-login-gate";
import { AppGateSplash } from "@/components/common/AppGateSplash";

interface OptionalAuthRouteProps {
  children: React.ReactNode;
}

/**
 * Public sayfalar. Oturum yoksa guest; varsa PrivateRoute ile aynı
 * agreements → persona → gamification sırası.
 */
export function OptionalAuthRoute({ children }: OptionalAuthRouteProps) {
  const { user, refreshToken, isTokenExpired } = useAuthStore();
  const location = useLocation();
  const gate = usePostLoginGate();

  const hasSession = !!(user && (!isTokenExpired() || refreshToken));

  if (!hasSession) {
    return <>{children}</>;
  }

  const redirect = resolvePostLoginRedirect(location.pathname, gate);

  if (redirect === "loading") {
    return <AppGateSplash />;
  }

  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>;
}
